import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-export-destinations',
  templateUrl: './help-export-destinations.component.html',
  styleUrls: ['./help-export-destinations.component.scss']
})
export class HelpExportDestinationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
